import React from "react";
import { FaLinkedin, FaMedium, FaGithub } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <a
        href="https://www.linkedin.com/in/sashita-ghimire/"
        target="_blank"
        rel="noreferrer"
      >
        <FaLinkedin />
      </a>
      <a
        href="https://github.com/sashitaghimire"
        target="_blank"
        rel="noreferrer"
      >
        <FaGithub />
      </a>
      <a
        href="https://medium.com/@ghimiresashita/list/reading-list"
        target="_blank"
        rel="noreferrer"
      >
        <FaMedium />
      </a>
    </div>
  );
};

export default SocialMedia;
